import { MenuItemProps } from '@silverfort/sf-components';
import { isPageHidden } from './isPageHidden';

type MenuItemWrapperProps = {
    id: string | number;
    userData: UserData | undefined;
    children: React.ReactElement<MenuItemProps> | React.ReactElement<MenuItemProps>[];
    hideCondition?: boolean;
};

export const MenuItemWrapper: React.FC<MenuItemWrapperProps> = ({ id, userData, children, hideCondition }) => {
    const isHidden = isPageHidden(userData, id);

    if (isHidden || hideCondition) {
        return null;
    }

    return <div>{children}</div>;
};
